const announcements2023Array = [

    {
        link: "https://files.iittp.ac.in/pdfs/announcements/2023/FESSIITTRECT-OS082023_Selection_List.pdf",
        title: "Selected Candidates List - Ambulance Driver",
        modal: false,
    }, 

    {
        link: "https://files.iittp.ac.in/pdfs/announcements/2023/IITTTPGen%20AdminTemp202301_Results_placement%20officer.pdf",
        title: "Selected Candidate List - Placement Officer",
        modal: false,
    }, 
    {
        link: "https://files.iittp.ac.in/pdfs/announcements/2023/Advt%20IITTCSRC2023-2419.pdf",
        title: "Advertisement for the post of Research Associate / Research Assistant-I - Department of Physics",
        modal: false,
    },
    {
        link: "https://files.iittp.ac.in/pdfs/announcements/2023/Notification_for_Guesthouse_Staff.pdf",
        title: "Notification for Outsourced Positions - Guesthouse Staff",
        modal: false,
    },

    {
        link: "https://files.iittp.ac.in/pdfs/announcements/2023/IITTTPGen%20AdminTemp202301_shortlisted-candidates_PO.pdf",
        title: "Shortlisted Candidates List - Placement Officer",
        modal: false,
    },

    {
        link: "https://files.iittp.ac.in/pdfs/announcements/2023/FESSIITTRECT-OS052023_Selected_List-Accounts.pdf",
        title: "Selected Candidates List - Project Junior Executive (Accounts)",
        modal: false,
    },  
    {
        link: "https://files.iittp.ac.in/pdfs/announcements//2023/Advt%20IITTCSRC2023-2417.pdf",
        title: "Advertisement for the position of Junior Research Fellow (JRF) - Department of Mechanical Engineering",
        modal: false,
    },
    {
        link: "https://files.iittp.ac.in/pdfs/announcements//2023/Advt%20IITTCSRC2023-2416.pdf",
        title: "Advertisement for the position of Postdoctoral Researcher / Project Scientist / Project Manager",
        modal: false,
    },

    {
        link: "https://files.iittp.ac.in/pdfs/announcements//2023/FESSITTPRECT-OS082023_Short%20listed_Candidates-EU.pdf",
        title: "Shortlisted Candidates - Technical Positions - Engineering Unit",
        modal: false,
    },
    {
        link: "https://files.iittp.ac.in/pdfs/announcements//2023/ITTPRECT-OS082023_Short%20listed_Candidates.pdf",
        title: "Shortlisted Candidates - Ambulance Driver",
        modal: false,
    }
    ,
    {
        link: "https://files.iittp.ac.in/pdfs/announcements//2023/IITTPLIBINTERNAdvt%202023-2401_Result.pdf",
        title: "RESULTS - Library Information Assistant-Intern",
        modal: false,
    },
    {
        link: "https://files.iittp.ac.in/pdfs/announcements//2023/Advt%20IITTCSRC2023-2415.pdf",
        title: "Recruitment for the post of “Research Associate - I (RA-1)” under MOE funded project",
        modal: false,
    },
    {
        link: "https://files.iittp.ac.in/pdfs/announcements//2023/Apprenticeship_Selection_Result.pdf",
        title: "List of Provisionally Selected Candidates for 1 - Year Apprenticeship Programme for Graduate/ Diploma under NATS",
        modal: false,
    },
    {
        link: "https://iittp.ac.in/Announcements#OP_AD_1_12",
        title: "Notification for Outsourced Positions - Ambulance Driver",
        modal: false,
    },
      
    {
        link: "https://iittp.ac.in/Announcements#EU_OP_30_12",
        title: "Notification for Outsourced Technical Positions - Engineering Unit ",
        modal: false,
    },
    {
        link: "https://files.iittp.ac.in/pdfs/announcements//2023/ITTP%20RECT-OS052023_Short%20listed_Candidates%20-%20Pr%20JE%20-%20Accounts.pdf",
        title: "Shortlisted Candidates - Project Junior Executive(Accounts)",
        modal: false,
    },
    {
        link: "https://files.iittp.ac.in/pdfs/announcements/2023/Advt%20IITTCSRC2023-2414.pdf",
        title: "Advertisement for the position of Project Scientist – I (Department of Electrical Engineering)",
        modal: false,
    },
    {
        link: "https://files.iittp.ac.in/pdfs/announcements/2023/IITTPLIBInterns2023-2404_Short%20listed_LIA_Interns_2023.pdf",
        title: "List of Provisionally Shortlisted / Not Shortlisted Candidates for Library Information Assistant - Intern Programme.",
        modal: false,
    },
    {
        link: "https://iittp.ac.in/announcements#PO_CB",
        title: "Advertisement for the Placement Officer on Contract Basis",
        modal: false,
    },
    {
        link: "https://files.iittp.ac.in/pdfs/announcements/2023/Apprenticeship%20shortlisted%20&%20Not%20shortlisted%20Candiates.pdf",
        title: "List of Provisionally Shortlisted / Not Shortlisted candidates for 1-year Apprenticeship Programme for Graduate/Diploma under NATS",
        modal: false,
    },
    {
        link: "https://iittp.ac.in/recruitment",
        title: "Result - Staff Recruitment (IITT/STAFFREC/02/2023 dated 23.08.2023)",
        modal: false,
    },
    {
        link: "https://iittp.ac.in/msphd-admissions/",
        title: "Shortlisted Candidates - M.S(R) and Ph.D. Admissions August 2023",
        modal: false,
    },
    {
        link: "https://files.iittp.ac.in/pdfs/announcements/2023/Advt IITTCSRC2023-2411.pdf",
        title: "Recruitment for the post of “Research Associate/Research Assistant” under Special Call for Short-term Empirical Research",
        modal: false,
    },
    {
        link: "#AP_TP",
        title: "Advertisement for 1 year Apprenticeship Training Program for Graduate & Technician (Diploma Holders) under NATS - Extended till 03.10.2023",
        modal: true,
    },
    {
        link: "https://files.iittp.ac.in/pdfs/announcements/2023/Advt IITTCSRC2023-2410.pdf",
        title: "Recruitment for the post of “Post-Doctoral Research fellow (Research Associate)” under DST funded project",
        modal: false,
    },
    {
        link: "https://iittp.ac.in/admissions",
        title: "Admissions for M.S.(R) and Ph.D. Programmes",
        modal: false,
    },
    {
        link: "https://iittp.ac.in/recruitment",
        title: "Advertisement for various Non-Teaching Staff Positions (Regular)",
        modal: false,
    },
    {
        link: "https://files.iittp.ac.in/pdfs/announcements/2023/FESSIITTPOS042023_Selected-list.pdf",
        title: "Results - Outsourced Positions - Sports Coaches & Gym Trainer",
        modal: false,
    },
    {
        link: "https://files.iittp.ac.in/pdfs/announcements/2023/Advt IITTCSRC2023-2408.pdf",
        title: "Advertisement for the position of Junior Research Fellow - Department of Mechanical Engineering (Last date extended up to 10th September, 2023)",
        modal: false,
    },
    {
        link: "https://files.iittp.ac.in/pdfs/announcements/2023/Advt IITTCSRC2023-2409.pdf",
        title: "Advertisement for the position of Research Technician for Research on Food Security - Department of Humanities and Social Sciences (Last date extended up to 8th September, 2023)",
        modal: false,
    },
    {
        link: "https://files.iittp.ac.in/pdfs/announcements/2023/Advt_IITT_CSRC_2023-24_07.pdf",
        title: "Advertisement for the position of Junior Research Fellow - Department of Chemical Engineering",
        modal: false,
    },
    {
        link: "https://iittp.ac.in/admissions",
        title: "Spot Round of Admissions for M.Sc. and M.Tech Programs for the Academic Year 2023-24",
        modal: false,
    },
    {
        link: "https://files.iittp.ac.in/pdfs/announcements/2023/Advt. IITTCSRC2023-2406.pdf",
        title: "Advertisement for the position of Junior Research Fellow",
        modal: false,
    },
    {
        link: "https://files.iittp.ac.in/pdfs/announcements/2023/IITTStaff RMT012023Registrar_Result.pdf",
        title: "Selected Candidate for the Post of Registrar at IIT Tirupati.",
        modal: false,
    },
    {
        link: "https://files.iittp.ac.in/pdfs/announcements/2023/FESSIITTOS012023_Selected List-HoME.pdf",
        title: "Results - Outsourced Positions - Hostel and Mess Establishment",
        modal: false,
    },
    {
        link: "https://files.iittp.ac.in/pdfs/announcements/2023/FESSIITTPRECT-OS032023_Short listed Candidates.pdf",
        title: "Shortlisted Candidates for Nursing Practitioner (Outsourced Position) - Health Centre",
        modal: false,
    },
    {
        link: "#EU_OP",
        title: "Notification for Technical Positions - Engineering Unit (Outsourced Position)",
        modal: true,
    },
    {
        link: "#SP_GT",
        title: "Notification for Sports Coaches & Gym Trainer - Hostel and Mess Establishment (Outsourced Position)",
        modal: true,
    },
    {
        link: "https://files.iittp.ac.in/pdfs/Orientation/2023/Orientation MS & PhD_2023.pdf",
        title: "Orientation Program for MS/Ph.D. Research Scholars - July 24-25, 2023",
        modal: false,
    },
    {
        link: "https://iittp.ac.in/important-information-for-new-students",
        title: "Important Information for New MS/Ph.D. 2023 Students",
        modal: false,
    },
    {
        link: "https://files.iittp.ac.in/pdfs/announcements/2023/Advt. IITTCSRC2023-2405.pdf",
        title: "Advertisement for the position of Junior Research Fellow - Mechanical Engineering",
        modal: false,
    },
    {
        link: "https://files.iittp.ac.in/pdfs/Orientation/2023/Orientation Mtech, Msc, MPP_2023.pdf",
        title: "Orientation Program for M.Tech/M.Sc./MPP - July 27 - August 02, 2023",
        modal: false,
    },
    {
        link: "#PH_LA",
        title: "Notification for Laboratory Assistant (Outsourced Position) - Department of Physics",
        modal: true,
    },
    {
        link: "https://iittp.ac.in/msphd-admissions/",
        title: "July 2023 Admissions - MS (Research) / Ph.D. Results - ME, EE & CEE",
        modal: false,
    },
    {
        link: "https://files.iittp.ac.in/pdfs/announcements/2023/Advt IITTCSRC2023-2403.pdf",
        title: "Advertisement for the position of Junior Research Fellow (1 post) - Chemical / Mechanical Engineering (Last date extended up to 09th July, 2023)",
        modal: false,
    },
    {
        link: "#HC_NP",
        title: "Notification for Nursing Practitioner (Outsourced Position) - Health Centre",
        modal: true,
    },
    {
        link: "https://files.iittp.ac.in/pdfs/announcements/2023/Advt IITTCSRC2023-2404.pdf",
        title: "Advertisement for the post of Project Scientist-I (Department of Mechanical Engineering)",
        modal: false,
    },
    {
        link: "https://iittp.ac.in/mpp-admissions-2023",
        title: "MPP Admissions 2023 - Selected Candidates List",
        modal: false,
    },
    {
        link: "https://files.iittp.ac.in/pdfs/announcements/2023/Advt IITTCSRC2023-2402.pdf",
        title: "Advertisement for the position of Junior Research Fellow (2 posts) - Chemical / Mechanical Engineering",
        modal: false,
    },
    {
        link: "https://files.iittp.ac.in/pdfs/announcements/2023/FESSIITTOS012023.pdf",
        title: "Shortlisted Candidates ( Asst Manager & Junior Executive) - Hostel and Mess Establishment",
        modal: false,
    },
    {
        link: "https://files.iittp.ac.in/pdfs/announcements/2023/Open House Poster_2023.pdf",
        title: "Open House - An Interactive Session for Prospective Students 2023",
        modal: false,
    },
    {
        link: "https://iittp.ac.in/information-for-b-tech-2023-batch",
        title: "Information for B.Tech 2023 Batch Students and Preparatory 2023 Students",
        modal: false,
    },
    {
        link: "https://files.iittp.ac.in/pdfs/announcements/2023/STFIITTP RECT-OS14_Project Junior Executive (Accounts).pdf",
        title: "Results - Project Junior Executive (Accounts)",
        modal: false,
    },
    {
        link: "https://files.iittp.ac.in/pdfs/announcements/2023/Advt.IITTPCSRC2023-2401 - Extension.pdf",
        title: "Advertisement for the post of Project Associate (DTH Swayam Prabha Project at IIT Tirupati) (Last date extended up to 20th May, 2023)",
        modal: false,
    },
    {
        link: "https://files.iittp.ac.in/pdfs/announcements/2023/CSRC_Advertisement for project officer.pdf",
        title: "Advertisement for the post of Project Officer (Event Management & CSRC Administration support)",
        modal: false,
    },
    {
        link: "https://files.iittp.ac.in/pdfs/announcements/2023/Re - advertisement for Program Administrator- Intenational Affairs-18-04-2023.pdf",
        title: "Advertisement for the post of Program Administrator- International and Alumni Affairs on contract basis",
        modal: false,
    },
    {
        link: "#HoMe_AM",
        title: "Notification for outsourced positions (Asst Manager & Junior Executive) - Hostel and Mess Establishment",
        modal: true,
    },
    {
        link: "https://files.iittp.ac.in/pdfs/announcements/2023/AdvtIITTCSRC222324.pdf",
        title: "Notification for the Project Scientist III (Last date extended up to 30th April, 2023)",
        modal: false,
    },
    {
        link: "https://files.iittp.ac.in/pdfs/announcements/2023/AdvtIITTCSRC222326.pdf",
        title: "Notification for the Project Scientist I (Civil Engineering) (Last date extended up to 30th April, 2023)",
        modal: false,
    },
    {
        link: "https://files.iittp.ac.in/pdfs/announcements/2023/AdvtIITTCSRC222325.pdf",
        title: "Notification for the Project Scientist I (Mechanical Engineering) (Last date extended up to 30th April, 2023)",
        modal: false,
    },
    {
        link: "https://iittp.ac.in/admissions",
        title: "Admissions are now Open for: Ph.D., M.S.(R), M.Tech, MPP",
        modal: false,
    },
    {
        link: "https://files.iittp.ac.in/pdfs/announcements/2023/Advertisement for Program Administrator- International and Alumni Affairs.pdf",
        title: "Advertisement for the post of Program Administrator- International and Alumni Affairs on contract basis",
        modal: false,
    },
    {
        link: "https://files.iittp.ac.in/pdfs/announcements/2023/Chemistry_Lab Assistant_Results - STFIITTP RECT-OS13.pdf",
        title: "Results - Lab Assistant - Dept of Chemistry",
        modal: false,
    },
    {
        link: "#fa_03",
        title: "Notification for the Outsourcing Positions (Finance & Accounts)",
        modal: true,
    },
    {
        link: "https://files.iittp.ac.in/pdfs/announcements/2023/Advt IITTCSRC2022-2316.pdf",
        title: "Advertisement for the position of Junior Research Fellow - CSRC",
        modal: false,
    },
    {
        link: "#EU_01",
        title: "Notification for the Outsourced Positions - Engineering Unit",
        modal: true,
    },
];

export default announcements2023Array;
